import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { setupPage } from "./utils/pageSetup";

// Runs before React renders so the LCP image, fonts and metadata are discovered first.
setupPage();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-228" data-mp="26avec0otkj2n" />);
}